import React from 'react';

const ControlBar = ({
  isCameraOn,
  isMicOn,
  isScreenSharing,
  onToggleCamera,
  onToggleMic,
  onToggleScreenShare,
  onStartRecording,
  onStopRecording,
  classTimer,
}) => {
  return (
    <div className="card mt-2">
      <div className="card-body d-flex flex-wrap justify-content-between align-items-center">
        <div className="btn-group mb-2">
          <button
            className={`btn btn-sm ${isCameraOn ? 'btn-outline-primary' : 'btn-danger'}`}
            onClick={onToggleCamera}
          >
            {isCameraOn ? 'Camera On' : 'Camera Off'}
          </button>
          <button
            className={`btn btn-sm ${isMicOn ? 'btn-outline-primary' : 'btn-danger'}`}
            onClick={onToggleMic}
          >
            {isMicOn ? 'Mic On' : 'Mic Off'}
          </button>
          <button
            className={`btn btn-sm ${
              isScreenSharing ? 'btn-success' : 'btn-outline-primary'
            }`}
            onClick={onToggleScreenShare}
          >
            {isScreenSharing ? 'Sharing Screen' : 'Share Screen'}
          </button>
        </div>

        <div className="mb-2">
          <span className="badge bg-secondary">
            Class Time: {classTimer?.formatted || '00:00:00'}
          </span>
        </div>

        <div className="btn-group mb-2">
          <button className="btn btn-sm btn-outline-success" onClick={onStartRecording}>
            Start Recording
          </button>
          <button className="btn btn-sm btn-outline-danger" onClick={onStopRecording}>
            Stop Recording
          </button>
        </div>
      </div>
    </div>
  );
};

export default ControlBar;
